import React from 'react';
import { Link } from '@reach/router';
// import { I18n } from '@kineticdata/react';
import { get } from 'immutable';
import {
  Card,
  CardCol,
  CardRow,
  services,
  C,
} from '@kineticdata/bundle-common';

export const CategoryCard = get(
  services,
  'CategoryCard',
  ({ category, path, countOfMatchingForms, components, ...props }) => (
    <Card {...props} to={path} components={{ Link, ...(components || {}) }}>
      <CardRow>
        <CardCol type={['prepend', 'icon']} className="my-2">
          <span
            className={`${
              category.icon ? `fa fa-${category.icon}` : C.ICON_CATEGORY
            } fa-md`}
          />
        </CardCol>
        <CardCol>
          <CardRow type="subtitle" className="font-weight-normal">
            {category.name}
          </CardRow>
          {/*countOfMatchingForms > 0 && (
            <CardRow>
              <small className="text-muted">
                {countOfMatchingForms} <I18n>Services</I18n>
              </small>
            </CardRow>
          )*/}
        </CardCol>
      </CardRow>
    </Card>
  ),
);
